import React from 'react';
import Banners from 'bv-banners';

export default () => (
  <div className="site-top-banner-wrapper">
    <Banners location="Home" />
  </div>
);
